var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWashingMachine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 335.64 353.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-11,.cls-21,.cls-22,.cls-25,.cls-26,.cls-33,.cls-34{fill:none;}.cls-13,.cls-2{fill:#fff;}.cls-3{fill:#c8cad1;}.cls-4{fill:#d9e6ed;}.cls-5{fill:#acc6d1;}.cls-6{opacity:0.4;}.cls-7{fill:#303030;}.cls-8{fill:#c7c7c7;}.cls-9{fill:#9c9c9d;}.cls-10{fill:#bdbdbd;}.cls-11,.cls-13{stroke:#000;}.cls-11,.cls-13,.cls-21,.cls-22,.cls-25,.cls-26,.cls-33,.cls-34{stroke-miterlimit:10;}.cls-11{stroke-width:0.37px;}.cls-12{fill:#008fff;}.cls-13{stroke-width:1.39px;}.cls-14{fill:#cfcfcf;}.cls-15{fill:#9b9b9b;}.cls-16{fill:#c1c1c1;}.cls-17{fill:#84858b;}.cls-18{fill:url(#linear-gradient);}.cls-19{fill:url(#linear-gradient-2);}.cls-20{fill:url(#linear-gradient-3);}.cls-21{stroke:#9b9b9b;}.cls-22{stroke:#84858b;}.cls-23{fill:#dadada;}.cls-24{clip-path:url(#clip-path);}.cls-25{stroke:#bdbdbd;stroke-width:2px;}.cls-26{stroke:#fff;}.cls-27{clip-path:url(#clip-path-2);}.cls-28{fill:#adadad;}.cls-29{fill:#606060;}.cls-30{clip-path:url(#clip-path-3);}.cls-31{clip-path:url(#clip-path-4);}.cls-32{fill:#2c3638;}.cls-33{stroke:#606060;}.cls-34{stroke:#474949;}.cls-35{clip-path:url(#clip-path-5);}.cls-36{fill:#960002;}.cls-37{fill:#ff031c;}.cls-38{fill:#b97109;}.cls-39{fill:#ff9c0e;}.cls-40{fill:#02782c;}.cls-41{fill:#00de42;}.cls-42{fill:#b4b4b4;}.cls-43{fill:#303b3e;}.cls-44{fill:#f44d4d;}.cls-45{fill:#f66562;}.cls-46{fill:#d0d6e2;}.cls-47{fill:#474949;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 217.61,
    y1: 122.45,
    x2: 217.61,
    y2: 237.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#474949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30b8c1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 99.57,
    y1: 80.59,
    x2: 99.57,
    y2: 235.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 66.32,
    y1: 178.08,
    x2: 102.9,
    y2: 178.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.17,4.15l-66.5,21.6C49.44,28.93,49.7,35,49.7,44V54.43h0c.07.68.82,1.34,2.18,1.76,2.29.71,5.39.46,6.92-.55a1.56,1.56,0,0,0,.85-1.21h0v0h0V40.75c0-3,0-6,6.65-8.16l59.85-19.44c6.65-2.17,6.65.83,6.65,6.83v7.68h0c.08.68.83,1.34,2.19,1.76,2.28.71,5.38.46,6.92-.55a1.57,1.57,0,0,0,.84-1.21h0v0h0V16.74C142.8,7.74,139.47-.18,126.17,4.15Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.85,5.54c-.07-.68-.82-1.35-2.18-1.77-2.29-.7-5.39-.46-6.92.55a1.56,1.56,0,0,0-.85,1.22h0v0h0V15.62h0c.08.68.83,1.34,2.19,1.76,2.28.71,5.38.46,6.92-.55a1.57,1.57,0,0,0,.84-1.21h0v0h0v-10Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.22,69.41,172.72,91c-10.23,3.18-10,9.24-10,18.24V119.7h0c.07.67.82,1.34,2.18,1.76,2.29.7,5.39.46,6.92-.55a1.56,1.56,0,0,0,.85-1.21h0v0h0V106c0-3,0-6,6.65-8.16l59.85-19.45c6.65-2.16,6.65.84,6.65,6.84v7.68h0c.08.68.83,1.34,2.19,1.76,2.28.71,5.38.46,6.92-.55a1.57,1.57,0,0,0,.84-1.21h0v0h0V82C255.84,73,252.52,65.09,239.22,69.41Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.9,70.8c-.08-.68-.83-1.34-2.18-1.76-2.29-.7-5.39-.46-6.93.55A1.57,1.57,0,0,0,205,70.8h0v0h0V80.89h0c.08.68.83,1.34,2.18,1.76,2.29.71,5.39.46,6.93-.55a1.57,1.57,0,0,0,.84-1.21h0v0h0V70.8Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.13,26.1c-.07-.68-.82-1.34-2.18-1.76-2.29-.71-5.38-.46-6.92.55a1.52,1.52,0,0,0-.84,1.21h0v0h0l0,74.65c.07.68.82,1.34,2.18,1.77,2.29.7,5.38.46,6.92-.55a1.58,1.58,0,0,0,.84-1.22h0v0h0V26.1Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Jar_01b",
    "data-name": "Jar_01b",
    viewBox: "0 0 9.26 18.96"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.26,4.77h0c0-.65-.75-1.28-2-1.68a8.8,8.8,0,0,0-6.42.5A1.41,1.41,0,0,0,0,4.77H0V16.91H0c0,.65.75,1.28,2.05,1.68a8.8,8.8,0,0,0,6.42-.5,1.41,1.41,0,0,0,.79-1.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.33,1.64h0c0-.52-.59-1-1.63-1.34A7,7,0,0,0,1.56.7a1.08,1.08,0,0,0-.63.94h0v2h0c0,.51.59,1,1.63,1.34a7,7,0,0,0,5.14-.4,1.1,1.1,0,0,0,.63-.94h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 4.63,
    cy: 1.82,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(2.76 6.43) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M9.26,4.77a.24.24,0,0,0,0-.09,1.32,1.32,0,0,1-.76,1.26c-1.42.93-4.3,1.15-6.42.5C.74,6,0,5.41,0,4.76H0V16.91H0c0,.65.75,1.28,2.05,1.68a8.8,8.8,0,0,0,6.42-.5,1.41,1.41,0,0,0,.79-1.18h0V4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2.05,6.44c-1.3-.4-2-1-2-1.67H0V16.91H0c0,.65.75,1.28,2.05,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8.31,1.56A1.37,1.37,0,0,1,7.43,3a7.21,7.21,0,0,1-5.21.19C1.15,2.8.9,2.1.94,1.55c0,0,0,.06,0,.09h0v2c0,.51.59,1,1.63,1.34a7,7,0,0,0,5.14-.4,1.1,1.1,0,0,0,.63-.94h0v-2h0S8.31,1.59,8.31,1.56Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Jars_03",
    "data-name": "Jars_03",
    viewBox: "0 0 55.37 34.92"
  }, /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(0 15.96)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(15.37 11.08)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(30.74 4.88)",
    xlinkHref: "#Jar_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 18.96,
    transform: "translate(46.11)",
    xlinkHref: "#Jar_01b"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Vask_Machine_02a",
    "data-name": "Vask_Machine_02a",
    viewBox: "0 0 335.64 353.58"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("image", {
    width: 306,
    height: 182,
    transform: "translate(0 171.58)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M305.72,251.35h0v6.78h0c0,.46.56.91,1.48,1.19a6.29,6.29,0,0,0,4.66-.37,1,1,0,0,0,.57-.82h0v-6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M305.72,178.24V252.8h0c0,.46.56.9,1.48,1.19a6.33,6.33,0,0,0,4.66-.37,1,1,0,0,0,.57-.82h0v0h0V178.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "327.72 160.94 261.22 182.55 261.22 197.55 327.72 175.94 327.72 160.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "335.64 165.52 269.14 187.12 269.14 202.12 335.64 180.52 335.64 165.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M269.14,189.94l56.53-18.37c2.5-.81,4.52.56,4.52,3.06a6.79,6.79,0,0,1-4.52,6L269.14,199"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "259.17 181.37 269.14 187.12 335.64 165.52 325.67 159.76 259.17 181.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "259.17 181.37 261.22 182.55 261.22 197.55 259.17 196.37 259.17 181.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "267.09 185.94 269.14 187.12 269.14 202.12 267.09 200.94 267.09 185.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "259.17 181.37 261.22 182.55 261.22 191.55 259.17 190.37 259.17 181.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "267.09 185.94 269.14 187.12 269.14 196.12 267.09 194.94 267.09 185.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M247.72,267.36h0v14h0c.1.94,1.14,1.86,3,2.45,3.18,1,7.48.64,9.62-.76a2.2,2.2,0,0,0,1.17-1.69h0v0h0v-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M150.06,290.26h0v14h0c.1.94,1.14,1.86,3,2.45,3.18,1,7.48.64,9.61-.76a2.21,2.21,0,0,0,1.18-1.69h0v0h0v-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M90.21,255.7h0v14h0c.1.95,1.14,1.87,3,2.45,3.18,1,7.48.64,9.62-.76a2.17,2.17,0,0,0,1.17-1.69h0v0h0v-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M47,230.75h0v14h0c.11.94,1.15,1.86,3,2.45,3.17,1,7.48.64,9.61-.76a2.17,2.17,0,0,0,1.17-1.69h0v0h0v-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M166.07,127.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "169.88 126.53 169.88 306.53 269.62 274.12 269.62 94.12 169.88 126.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "36.88 52.75 163.22 125.69 163.22 305.69 36.88 232.75 36.88 52.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "163.22 125.69 169.88 126.53 169.88 306.53 163.22 305.69 163.22 125.69 163.22 125.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "36.88 52.75 163.22 125.69 169.88 126.53 269.62 94.12 139.95 19.26 36.88 52.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "172.72 143.45 172.72 245.45 262.49 216.28 262.49 114.28 172.72 143.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "102.9 109.14 159.78 141.98 159.78 243.98 102.9 211.14 102.9 109.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "39.72 72.67 66.32 88.03 66.32 190.03 39.72 174.67 39.72 72.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "66.32 88.03 102.54 108.93 102.9 166.14 66.32 145.03 66.32 88.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M212.62,136.49v90l-33.25,10.8v-90Zm10-3.24v90l33.25-10.8v-90Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M156.09,145.86v90l-23.27-13.49v-90Zm-113-65.27v90l20,11.57v-90Zm63.17,36.47v90l16.63,9.6V126.6ZM69.65,95.94v45l26.6,15.36v-45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "102.9 166.14 102.9 211.14 66.32 190.03 66.32 145.03 102.9 166.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "186.5 262.13 186.5 265.13 203.13 259.71 203.13 256.73 186.5 262.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "236.37 245.93 236.37 248.93 253.01 243.51 253.01 240.52 236.37 245.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "133.3 252.42 146.6 260.1 146.6 263.1 133.3 255.42 133.3 252.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "93.4 229.38 106.7 237.06 106.7 240.06 93.4 232.38 93.4 229.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "53.22 206.18 66.52 213.86 66.52 216.86 53.22 209.18 53.22 206.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "176.53 259.37 176.53 298.37 213.1 286.49 213.1 247.49 176.53 259.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "226.4 243.17 226.4 282.17 262.97 270.29 262.97 231.28 226.4 243.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "156.57 259.86 156.57 298.86 123.33 279.66 123.33 240.66 156.57 259.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "116.68 236.82 116.68 275.82 83.43 256.62 83.43 217.62 116.68 236.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "76.78 213.78 76.3 252.49 43.53 233.59 43.53 194.59 76.78 213.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M126.17,4.15l-66.5,21.6C49.44,28.93,49.7,35,49.7,44V54.43h0c.07.68.82,1.34,2.18,1.76,2.29.71,5.39.46,6.92-.55a1.56,1.56,0,0,0,.85-1.21h0v0h0V40.75c0-3,0-6,6.65-8.16l59.85-19.44c6.65-2.17,6.65.83,6.65,6.83v7.68h0c.08.68.83,1.34,2.19,1.76,2.28.71,5.38.46,6.92-.55a1.57,1.57,0,0,0,.84-1.21h0v0h0V16.74C142.8,7.74,139.47-.18,126.17,4.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M135.86,30.55V16.6c0-6-1.16-8.63-7.81-6.47L100.14,19.2,65,30.62c-10.23,3.18-8.21,8.67-8.21,17.67V58.72h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M141.22,29.69V18.81c0-9-1.05-17.66-14.35-13.34L62.53,26.37c-10.23,3.18-10,9.24-10,18.24v14.5l0-4.06"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M101.85,5.54c-.07-.68-.82-1.35-2.18-1.77-2.29-.7-5.39-.46-6.92.55a1.56,1.56,0,0,0-.85,1.22h0v0h0V15.62h0c.08.68.83,1.34,2.19,1.76,2.28.71,5.38.46,6.92-.55a1.57,1.57,0,0,0,.84-1.21h0v0h0v-10Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 93.55,
    y1: 5.86,
    x2: 93.55,
    y2: 18.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 99.18,
    y1: 5.86,
    x2: 99.18,
    y2: 18.55
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.89,
    cy: 5.86,
    rx: 2.01,
    ry: 4.55,
    transform: "translate(89.98 102.67) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "163.48 83.76 163.22 92.69 206.71 78.72 206.71 69.72 163.48 83.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "99.77 46.98 99.77 55.98 163.22 92.69 163.48 83.76 99.77 46.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "153.51 24 127 8.61 153.51 0 180.11 15.36 153.51 24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "127 8.61 153.51 24 163.48 83.76 99.77 46.98 127 8.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "153.51 24 163.48 83.76 206.71 69.72 180.11 15.36 153.51 24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M239.22,69.41,172.72,91c-10.23,3.18-10,9.24-10,18.24V119.7h0c.07.67.82,1.34,2.18,1.76,2.29.7,5.39.46,6.92-.55a1.56,1.56,0,0,0,.85-1.21h0v0h0V106c0-3,0-6,6.65-8.16l59.85-19.45c6.65-2.16,6.65.84,6.65,6.84v7.68h0c.08.68.83,1.34,2.19,1.76,2.28.71,5.38.46,6.92-.55a1.57,1.57,0,0,0,.84-1.21h0v0h0V82C255.84,73,252.52,65.09,239.22,69.41Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M248.91,95.82v-14c0-6-1.16-8.62-7.81-6.46l-27.91,9.07L178.05,95.89c-10.23,3.17-8.21,8.67-8.21,17.67V124h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M254.26,95V84.07c0-9-1-17.66-14.35-13.33l-64.33,20.9c-10.23,3.18-10,9.24-10,18.24v14.5l0-4.07"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M214.9,70.8c-.08-.68-.83-1.34-2.18-1.76-2.29-.7-5.39-.46-6.93.55A1.57,1.57,0,0,0,205,70.8h0v0h0V80.89h0c.08.68.83,1.34,2.18,1.76,2.29.71,5.39.46,6.93-.55a1.57,1.57,0,0,0,.84-1.21h0v0h0V70.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 206.59,
    y1: 71.12,
    x2: 206.59,
    y2: 83.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 212.22,
    y1: 71.12,
    x2: 212.22,
    y2: 83.81
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.93,
    cy: 71.12,
    rx: 2.01,
    ry: 4.55,
    transform: "translate(136.54 280.28) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M42.27,274.12h0v6.78h0c.05.46.55.91,1.47,1.19a6.32,6.32,0,0,0,4.67-.37,1,1,0,0,0,.56-.82h0V274.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M42.27,201v74.56h0c.05.46.55.91,1.47,1.19a6.32,6.32,0,0,0,4.67-.37,1,1,0,0,0,.56-.82h0V201Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "94.97 173.57 28.47 195.17 28.47 210.17 94.97 188.57 94.97 173.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "102.9 178.14 36.4 199.75 36.4 214.75 102.9 193.14 102.9 178.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M102.9,190.19,46.37,208.55c-2.5.81-4.52-.55-4.52-3.05a6.79,6.79,0,0,1,4.52-6l56.53-18.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "26.42 193.99 36.4 199.75 102.9 178.14 102.9 169.14 26.42 193.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "26.42 193.99 28.47 195.17 28.47 210.17 26.42 208.99 26.42 193.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "34.35 198.56 36.4 199.75 36.4 214.75 34.35 213.56 34.35 198.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "26.42 193.99 28.47 195.17 28.47 204.17 26.42 202.99 26.42 193.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "34.35 198.56 36.4 199.75 36.4 208.75 34.35 207.56 34.35 198.56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 47.24,
    cy: 203.93,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-138.7 107.78) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 57.21,
    cy: 200.69,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-132.72 114.23) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 67.19,
    cy: 197.45,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-126.74 120.69) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 77.16,
    cy: 194.21,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-120.76 127.15) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 87.14,
    cy: 190.97,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-114.78 133.6) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 97.11,
    cy: 187.72,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-108.8 140.06) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 274.52,
    cy: 192.22,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-49.77 276.77) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 284.49,
    cy: 188.98,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-43.78 283.23) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 294.47,
    cy: 185.74,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-37.8 289.69) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 304.44,
    cy: 182.5,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-31.82 296.14) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 314.42,
    cy: 179.26,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-25.84 302.6) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 324.39,
    cy: 176.02,
    rx: 2.42,
    ry: 1.75,
    transform: "translate(-19.86 309.06) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-33",
    x1: 161.62,
    y1: 72.22,
    x2: 201.6,
    y2: 59.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 104.13,
    y1: 39.74,
    x2: 160.84,
    y2: 72.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M146.13,26.1c-.07-.68-.82-1.34-2.18-1.76-2.29-.71-5.38-.46-6.92.55a1.52,1.52,0,0,0-.84,1.21h0v0h0l0,74.65c.07.68.82,1.35,2.18,1.77,2.29.7,5.38.46,6.92-.55a1.56,1.56,0,0,0,.84-1.22h0v0h0V26.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 137.83,
    y1: 26.42,
    x2: 137.83,
    y2: 103.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 143.46,
    y1: 26.42,
    x2: 143.46,
    y2: 103.71
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 141.17,
    cy: 26.15,
    rx: 2.2,
    ry: 4.99,
    transform: "translate(113.49 167.03) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M146.14,28.16a1.46,1.46,0,0,1-.83,1.31c-1.54,1-4.63,1.24-6.92.54-1.43-.43-2.2-1.12-2.21-1.83l0,9.25c.07.68.82,1.34,2.18,1.76,2.29.71,5.39.46,6.92-.54a1.54,1.54,0,0,0,.84-1.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 139.56,
    y: 31.91,
    width: 3.16,
    height: 5.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M146.14,37.33a1.47,1.47,0,0,1-.83,1.32c-1.53,1-4.63,1.24-6.92.54-1.43-.44-2.2-1.13-2.21-1.83l0,9.24c.07.68.82,1.35,2.18,1.77,2.29.7,5.39.46,6.92-.55a1.56,1.56,0,0,0,.85-1.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 139.56,
    y: 41.08,
    width: 3.16,
    height: 5.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M146.14,46.5a1.47,1.47,0,0,1-.83,1.32c-1.53,1-4.63,1.24-6.92.54-1.43-.44-2.2-1.12-2.21-1.83l0,9.25c.07.68.82,1.34,2.18,1.76,2.29.71,5.39.46,6.92-.55a1.56,1.56,0,0,0,.85-1.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 139.56,
    y: 50.14,
    width: 3.16,
    height: 5.42
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "159.9 39.77 166.55 61.62 193.15 52.97 186.5 31.13 159.9 39.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "163.22 41.7 168.19 58.08 189.82 51.05 184.8 34.69 163.22 41.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M171.8,47.49a2.72,2.72,0,0,1-3.93.21,4.5,4.5,0,0,1-1.08-5,3.83,3.83,0,0,1,.56-.92,2.72,2.72,0,0,1,3.93-.21,4.51,4.51,0,0,1,1.09,5A3.4,3.4,0,0,1,171.8,47.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M172.57,40.87l-3.5,1.21a1.75,1.75,0,0,0-1.18,1.1,3.37,3.37,0,0,0,.77,3.62,1.59,1.59,0,0,0,1.29.42l3.94-1.32a1.85,1.85,0,0,0,1-1,3.35,3.35,0,0,0-.77-3.62A1.55,1.55,0,0,0,172.57,40.87Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-45",
    cx: 173.21,
    cy: 43.39,
    rx: 1.9,
    ry: 2.62,
    transform: "translate(-4.54 26.43) rotate(-8.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M180.31,44.44a2.39,2.39,0,0,1-3.5.19,4.26,4.26,0,0,1-1-4.65,3,3,0,0,1,.52-.84,2.39,2.39,0,0,1,3.5-.19,4.26,4.26,0,0,1,1,4.66A3,3,0,0,1,180.31,44.44Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-46",
    cx: 178.31,
    cy: 41.79,
    rx: 1.9,
    ry: 2.62,
    transform: "translate(-4.25 27.18) rotate(-8.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M182.31,51.8a2.41,2.41,0,0,1-3.51.18,4.25,4.25,0,0,1-1-4.65,2.89,2.89,0,0,1,.51-.83,2.39,2.39,0,0,1,3.5-.19,4.25,4.25,0,0,1,1,4.65A3.19,3.19,0,0,1,182.31,51.8Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-46",
    cx: 180.31,
    cy: 49.15,
    rx: 1.9,
    ry: 2.62,
    transform: "translate(-5.33 27.56) rotate(-8.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M173.94,54.82a2.4,2.4,0,0,1-3.51.19,4.25,4.25,0,0,1-1-4.65,3.19,3.19,0,0,1,.51-.84,2.41,2.41,0,0,1,3.51-.18,4.25,4.25,0,0,1,1,4.65A2.89,2.89,0,0,1,173.94,54.82Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-46",
    cx: 171.94,
    cy: 52.17,
    rx: 1.9,
    ry: 2.62,
    transform: "translate(-5.87 26.34) rotate(-8.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "181.6 38.57 184.93 49.49 187.05 48.8 183.72 37.88 181.6 38.57"
  }), /*#__PURE__*/React.createElement("use", {
    width: 55.37,
    height: 34.92,
    transform: "translate(36.91 160.09)",
    xlinkHref: "#Jars_03"
  }), /*#__PURE__*/React.createElement("use", {
    width: 55.37,
    height: 34.92,
    transform: "translate(272.13 146.57)",
    xlinkHref: "#Jars_03"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vask_Sterilisation",
    "data-name": "Vask & Sterilisation"
  }, /*#__PURE__*/React.createElement("use", {
    width: 335.64,
    height: 353.58,
    xlinkHref: "#Vask_Machine_02a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWashingMachine2);
export default __webpack_public_path__ + "static/media/washing-machine-2.6cfd424cb4b2bb41ef8de9005132fda6.svg";
export { ForwardRef as ReactComponent };